jQuery(document).ready(function(){

	jQuery('.testimonials-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		]
	});

	new WOW().init();
});
// menu

function openNav() {
	jQuery('#mySidenav').addClass('open');  
}

function closeNav() {
	jQuery('#mySidenav').removeClass('open');  
}


/************************************************************
* Sticky Header Menu
* On scroll make the header menu stick to the top
* Only apply this class once user scrolls past header bar
*************************************************************/
jQuery(window).scroll(function() {
  var topheader = jQuery('header .header-bar').outerHeight();
  var myheight = jQuery(window).scrollTop();
  if(myheight > topheader){
    jQuery('header .logo-bar').addClass('sticky-menu');
  }
  if(myheight < topheader){
    jQuery('header .logo-bar').removeClass('sticky-menu');
  }
  if(myheight == 0){
    jQuery('header .logo-bar').removeClass('sticky-menu');
  }    		
});